var _rect, _path, _path2, _path3, _path4, _path5, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBoxOpen = function SvgBoxOpen(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 42H86V104H20C16.6863 104 14 101.314 14 98V42Z",
    fill: "url(#paint0_linear_2215_6979)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86 42H114V98C114 101.314 111.314 104 108 104H86V42Z",
    fill: "url(#paint1_linear_2215_6979)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 42H86L80.7079 59.5766C80.4535 60.4216 79.6753 61 78.7928 61H10.9702C9.62964 61 8.66863 59.707 9.05512 58.4234L14.0001 42Z",
    fill: "url(#paint2_linear_2215_6979)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.481 26.7837C121.043 25.4645 120.075 24 118.641 24H94.9888C94.1871 24 93.4629 24.4787 93.1487 25.2163L86.0001 42H114L120.481 26.7837Z",
    fill: "url(#paint3_linear_2215_6979)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33151 26.6946C7.84771 25.3884 8.81404 24 10.207 24H33.9414C34.7781 24 35.5263 24.5208 35.8169 25.3054L42.0001 42H14.0002L8.33151 26.6946Z",
    fill: "url(#paint4_linear_2215_6979)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 48,
    width: 18,
    height: 6,
    rx: 3,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2215_6979",
    x1: 37.625,
    y1: 128.5,
    x2: 44.5855,
    y2: 49.6215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2215_6979",
    x1: 79.84,
    y1: 116.13,
    x2: 199.281,
    y2: 72.7823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2215_6979",
    x1: 46.5001,
    y1: 63,
    x2: 46.1808,
    y2: 47.9962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2215_6979",
    x1: 101.408,
    y1: 32.1694,
    x2: 97.4666,
    y2: 11.6659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2215_6979",
    x1: 27.0246,
    y1: 32.1694,
    x2: 31.0709,
    y2: 11.7085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C2FF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBoxOpen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "box-open.c337bcd9a106f487c788c6c565a1c416.svg";